/* Publish by EComposer at 2026-11-04 04:27:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4hgs1t6h8gb"]=  window.__ectimmers["ecom-4hgs1t6h8gb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4hgs1t6h8gb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4hgs1t6h8gb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4hgs1t6h8gb', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1ih8dt09uou"]=  window.__ectimmers["ecom-1ih8dt09uou"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-1ih8dt09uou"]["rh4uj27u4"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-1ih8dt09uou').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1ih8dt09uou', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1ih8dt09uou', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dr8r9sn4r9r"]=  window.__ectimmers["ecom-dr8r9sn4r9r"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-dr8r9sn4r9r"]["yrsk03sv3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-dr8r9sn4r9r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dr8r9sn4r9r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dr8r9sn4r9r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rll9dv8jel').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rll9dv8jel', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rll9dv8jel', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u84vqbeaa2e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u84vqbeaa2e', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u84vqbeaa2e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7at03rzb9zy').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7at03rzb9zy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7at03rzb9zy', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cw4kqxppzj9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cw4kqxppzj9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cw4kqxppzj9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-bqqc29wukve').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-bqqc29wukve', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-bqqc29wukve', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}